module.exports = __webpack_public_path__ + "static/media/demo-2.93e387b8.jpg";